// ** I18n Imports
import i18n from 'i18next'
// import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
// import LanguageDetector from 'i18next-browser-languagedetector'
import translationEN from '@/assets/locales/en.json'
import translationTR from '@/assets/locales/tr.json'

i18n
  .use(initReactI18next)
  .init({
    lng: "tr",
    resources: {
      en: {
        translation: translationEN
      },
      tr: {
        translation: translationTR
      }
    },
    fallbackLng: 'en',
    debug: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  })

export default i18n
